<!--<section class="breadcrumb-area mt-0 py-4">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="breadcrumb-box text-center">
          <h1>{{h1 | uppercase}}</h1>
          <h2>{{categoryName$ | async}}</h2>
        </div>
      </div>
    </div>
  </div>
</section>-->
<!--MAIN-BANNER-->
<div style="background: #F9F9F9;" class="pt-3 pt-md-0">
  <div *ngIf="src_section" id="mainBannerMarket" class="mx-3 mx-md-0 pt-xl-3 pb-2">
    <div [ngStyle]="container?.style"
         class="mainBanner-container container position-relative d-flex align-items-center justify-content-around pr-0 pr-md-4">

      <div id="download-apps-top" class="d-flex flex-column align-items-start px-lg-4 ml-xl-5" style="flex:55%">
        <h1 class="h2 font-weight-bold  Poppins text-left text-white">{{h1}}
        </h1>
        <p *ngIf="subtitle" [ngStyle]="container?.subtitle?.style" class="text-left Poppins" style="font-size: 22px" [innerHTML]="subtitle"></p>
      </div>
      <div class="d-flex justify-content-end align-self-end" style="flex:45%">
        <img class="d-flex d-md-none" src="{{src_section}}.png" style="max-width: 178px"
             alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
        <img class="d-none d-md-block d-lg-none" style="max-width: 320px" src="{{src_section}}-md.png"
             alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
        <img class="d-none d-lg-block" style="max-width: 480px" src="{{src_section}}-md.png"
             alt="Cubatel - Llamadas, SMS, Recargas Nauta y Recargas a Cuba">
      </div>
    </div>
  </div>
</div>

<!--END-MAIN-BANNER-->

<section class="category pt-4">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="product-box">
          <div class="cat-box d-flex justify-content-between" [ngStyle]="(selectCategoryTreeView$ | async).length > 0 ? {'margin-bottom' : '10px'} : ''">
            <div class="view" style="min-width: 100px;">
              <ul ngbNav #nav="ngbNav" class="nav-tabs">
                <li [ngbNavItem]="1">
                  <a *ngIf="(provider$ | async)==0" ngbNavLink>
                    <i class="fa fa-th-large"></i>
                  </a>
                  <ng-template ngbNavContent>

                    <ng-container *ngIf="(provider$ | async)<2" >
                      <app-product-tab1 class="data-card" [data$]="this.items$">
                      </app-product-tab1>
                    </ng-container>

                    <div *ngIf="(provider$ | async)>=2" class="search-results"
                      infiniteScroll
                      [infiniteScrollDistance]="1"
                      [infiniteScrollThrottle]="800"
                      (scrolled)="onScroll()" [scrollWindow]="true">
                      <app-product-tab1 class="data-card" [data$]="this.items$">
                      </app-product-tab1>
                    </div>

                  </ng-template>
                </li>
                <li [ngbNavItem]="2">
                  <a *ngIf="(provider$ | async)==0" ngbNavLink>
                    <i class="fa fa-th-list"></i>
                  </a>
                  <ng-template ngbNavContent>
                    <app-product-tab2 [data$]="this.items$"></app-product-tab2>
                  </ng-template>
                </li>
              </ul>

            </div>

            <div *ngIf="(provider$ | async)==0" style="display: flex!important;padding-right: 25px;width: 30%;">

              <ngx-slider class="priceFilter" *ngIf="isBrowser" style="margin-right: 20px;z-index: 0" [value]="(this.configuration$ | async)?.priceFilter?.minValue"
                [highValue]="(this.configuration$ | async)?.priceFilter?.maxValue" [options]="{
                  translate:translateFn,
                  floor: (this.configuration$ | async)?.priceFilter?.minValue || 0,
                  ceil: (this.configuration$ | async)?.priceFilter?.maxValue || 10,
                  step: (this.configuration$ | async)?.priceFilter?.step || 10}" (userChangeEnd)="onChangeSlider($event)">
              </ngx-slider>

            </div>

            <div style="display: flex!important;padding-right: 25px;">

              <div *ngIf="(provider$ | async)==0" class="sortby" style="margin-right: 20px;">
                <span>Ordenar por:</span>
                <select class="sort-box" #sortingItems>
                  <option [selected]="(request$ | async).filter.sortingArgs === 0" value="0">Recomendados</option>

                  <option [selected]="(request$ | async).filter.sortingArgs === 4" value="4">Nuevo</option>

                  <option [selected]="(request$ | async).filter.sortingArgs === 1" value="1">Menor precio</option>

                  <option [selected]="(request$ | async).filter.sortingArgs === 2" value="2">Mayor precio</option>

                  <option [selected]="(request$ | async).filter.sortingArgs === 16" value="16">Oferta</option>

                  <option [selected]="(request$ | async).filter.sortingArgs === 8" value="8">Tiempo de entrega
                  </option>

                </select>
              </div>

             <!--  <div *ngIf="(count$ | async)>0" class="show-item" style="margin-right: 20px;">
                <span>Mostrar</span>
                <select class="show-box" #selectItems>
                  <option [selected]="(request$ | async ).pageSize === 8">8</option>
                  <option [selected]="(request$ | async ).pageSize === 12">12</option>
                  <option [selected]="(request$ | async ).pageSize === 24">24</option>
                  <option [selected]="(request$ | async ).pageSize === 50">50</option>
                </select>
              </div> -->

              <div *ngIf="(provider$ | async)<2" class="page">
                <p>Mostrando {{count$ | async}} de {{totalData$ | async}} resultados</p>
              </div>

              <div *ngIf="(provider$ | async)==2" class="page">
                <p>Mostrando {{count$ | async}} resultados</p>
              </div>

            </div>
          </div>
          <div *ngIf="(provider$ | async) == 0" class="d-flex justify-content-end mb-3">
            <ngx-dropdown-treeview *ngIf="(selectCategoryTreeView$ | async).length > 0 "
              [class.location-disable]="loadingCategoryTree$ | async"
              [config]="configTree"
              [items]="items"
              (selectedChange)="onSelectCategories($event)"
              autofocus=false
              [style.width]="'200px'"></ngx-dropdown-treeview>
          </div>
          <div [ngbNavOutlet]="nav"></div>
        </div>
      </div>
    </div>

  </div>
</section>

<section *ngIf="(count$ | async)>0" class="d-flex justify-content-center p-0 paginated">
  <ngb-pagination  *ngIf="(provider$ | async)==0" [maxSize]="5" [pageSize]="pageSize$ | async" [collectionSize]="totalData$ | async"
    (pageChange)="pageChange($event)" [page]="pageNo$ | async">
  </ngb-pagination>

<ngb-pagination  *ngIf="(provider$ | async)==1" [ellipses]="false" [maxSize]="5" [pageSize]="pageSize$ | async" [collectionSize]="totalData$ | async"
  (pageChange)="pageChange($event)" [page]="pageNo$ | async">
</ngb-pagination>

</section>

<section *ngIf="faqs.length > 0" class="d-flex justify-content-center p-0 paginated product-list-faq">
  <div class="container">
    <div class="row py-4">
      <div class="col-md-12 d-flex flex-column">
        <h2 class="p-2 font-weight-bold text-center with-line section-title">
          Preguntas frecuentes
        </h2>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <article class="col-12 col-lg-12 col-md-12">
          <div class="accordion" id="faq">
            <ng-container *ngIf="sectionId == 'comida'">
              <div class="card  mt-2">
                <div class="card-header" id="heading-comida-0" data-toggle="collapse" data-target="#collapse-comida-0" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-comida-0" aria-expanded="false" aria-controls="collapse-comida-0" [innerHTML]="faqs[0].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-comida-0" class="collapse" aria-labelledby="heading-comida-0" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[0].answer">

                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-comida-1" data-toggle="collapse" data-target="#collapse-comida-1" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-comida-1" aria-expanded="false" aria-controls="collapse-comida-1" [innerHTML]="faqs[1].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-comida-1" class="collapse" aria-labelledby="heading-comida-1" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[1].answer">

                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-comida-2" data-toggle="collapse" data-target="#collapse-comida-2" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-comida-2" aria-expanded="false" aria-controls="collapse-comida-2" [innerHTML]="faqs[2].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-comida-2" class="collapse" aria-labelledby="heading-comida-2" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[2].answer">

                    </p>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="sectionId == 'aseo'">
              <div class="card  mt-2">
                <div class="card-header" id="heading-aseo-0" data-toggle="collapse" data-target="#collapse-aseo-0" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-aseo-0" aria-expanded="false" aria-controls="collapse-aseo-0" [innerHTML]="faqs[0].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-aseo-0" class="collapse" aria-labelledby="heading-aseo-0" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[0].answer">

                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-aseo-1" data-toggle="collapse" data-target="#collapse-aseo-1" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-aseo-1" aria-expanded="false" aria-controls="collapse-aseo-1" [innerHTML]="faqs[1].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-aseo-1" class="collapse" aria-labelledby="heading-aseo-1" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[1].answer">

                    </p>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="sectionId == 'piezas-motos-carros'">
              <div class="card  mt-2">
                <div class="card-header" id="heading-piezas-motos-carros-0" data-toggle="collapse" data-target="#collapse-piezas-motos-carros-0" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-piezas-motos-carros-0" aria-expanded="false" aria-controls="collapse-piezas-motos-carros-0" [innerHTML]="faqs[0].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-piezas-motos-carros-0" class="collapse" aria-labelledby="heading-piezas-motos-carros-0" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[0].answer">

                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-piezas-motos-carros-1" data-toggle="collapse" data-target="#collapse-piezas-motos-carros-1" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-piezas-motos-carros-1" aria-expanded="false" aria-controls="collapse-piezas-motos-carros-1" [innerHTML]="faqs[1].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-piezas-motos-carros-1" class="collapse" aria-labelledby="heading-piezas-motos-carros-1" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[1].answer">

                    </p>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="sectionId == 'bebida'">
              <div class="card  mt-2">
                <div class="card-header" id="heading-bebida-0" data-toggle="collapse" data-target="#collapse-bebida-0" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-bebida-0" aria-expanded="false" aria-controls="collapse-bebida-0" [innerHTML]="faqs[0].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-bebida-0" class="collapse" aria-labelledby="heading-bebida-0" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[0].answer">

                    </p>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="sectionId == 'combos'">
              <div class="card  mt-2">
                <div class="card-header" id="heading-combos-0" data-toggle="collapse" data-target="#collapse-combos-0" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-combos-0" aria-expanded="false" aria-controls="collapse-combos-0" [innerHTML]="faqs[0].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-combos-0" class="collapse" aria-labelledby="heading-combos-0" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[0].answer">

                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-combos-1" data-toggle="collapse" data-target="#collapse-combos-1" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-combos-1" aria-expanded="false" aria-controls="collapse-combos-1" [innerHTML]="faqs[1].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-combos-1" class="collapse" aria-labelledby="heading-combos-1" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[1].answer">

                    </p>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="sectionId == 'medicamentos'">
              <div class="card  mt-2">
                <div class="card-header" id="heading-medicamentos-0" data-toggle="collapse" data-target="#collapse-medicamentos-0" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-medicamentos-0" aria-expanded="false" aria-controls="collapse-medicamentos-0" [innerHTML]="faqs[0].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-medicamentos-0" class="collapse" aria-labelledby="heading-medicamentos-0" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[0].answer">

                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-medicamentos-1" data-toggle="collapse" data-target="#collapse-medicamentos-1" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-medicamentos-1" aria-expanded="false" aria-controls="collapse-medicamentos-1" [innerHTML]="faqs[1].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-medicamentos-1" class="collapse" aria-labelledby="heading-medicamentos-1" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[1].answer">

                    </p>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="sectionId == 'ferreteria'">
              <div class="card  mt-2">
                <div class="card-header" id="heading-ferreteria-0" data-toggle="collapse" data-target="#collapse-ferreteria-0" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-ferreteria-0" aria-expanded="false" aria-controls="collapse-ferreteria-0" [innerHTML]="faqs[0].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-ferreteria-0" class="collapse" aria-labelledby="heading-ferreteria-0" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[0].answer">

                    </p>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="sectionId == 'electrodomesticos-hogar'">
              <div class="card  mt-2">
                <div class="card-header" id="heading-electrodomesticos-hogar-0" data-toggle="collapse" data-target="#collapse-electrodomesticos-hogar-0" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-electrodomesticos-hogar-0" aria-expanded="false" aria-controls="collapse-electrodomesticos-hogar-0" [innerHTML]="faqs[0].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-electrodomesticos-hogar-0" class="collapse" aria-labelledby="heading-electrodomesticos-hogar-0" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[0].answer">

                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-electrodomesticos-hogar-1" data-toggle="collapse" data-target="#collapse-electrodomesticos-hogar-1" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-electrodomesticos-hogar-1" aria-expanded="false" aria-controls="collapse-electrodomesticos-hogar-1" [innerHTML]="faqs[1].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-electrodomesticos-hogar-1" class="collapse" aria-labelledby="heading-electrodomesticos-hogar-1" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[1].answer">

                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-electrodomesticos-hogar-2" data-toggle="collapse" data-target="#collapse-electrodomesticos-hogar-2" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-electrodomesticos-hogar-2" aria-expanded="false" aria-controls="collapse-electrodomesticos-hogar-2" [innerHTML]="faqs[2].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-electrodomesticos-hogar-2" class="collapse" aria-labelledby="heading-electrodomesticos-hogar-2" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[2].answer">

                    </p>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="sectionId == 'celulares-computadoras'">
              <div class="card  mt-2">
                <div class="card-header" id="heading-celulares-computadoras-0" data-toggle="collapse" data-target="#collapse-celulares-computadoras-0" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-celulares-computadoras-0" aria-expanded="false" aria-controls="collapse-celulares-computadoras-0" [innerHTML]="faqs[0].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-celulares-computadoras-0" class="collapse" aria-labelledby="heading-celulares-computadoras-0" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[0].answer">

                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-celulares-computadoras-1" data-toggle="collapse" data-target="#collapse-celulares-computadoras-1" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-celulares-computadoras-1" aria-expanded="false" aria-controls="collapse-celulares-computadoras-1" [innerHTML]="faqs[1].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-celulares-computadoras-1" class="collapse" aria-labelledby="heading-celulares-computadoras-1" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[1].answer">

                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-celulares-computadoras-2" data-toggle="collapse" data-target="#collapse-celulares-computadoras-2" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-celulares-computadoras-2" aria-expanded="false" aria-controls="collapse-celulares-computadoras-2" [innerHTML]="faqs[2].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-celulares-computadoras-2" class="collapse" aria-labelledby="heading-celulares-computadoras-2" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[2].answer">

                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-celulares-computadoras-3" data-toggle="collapse" data-target="#collapse-celulares-computadoras-3" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-celulares-computadoras-3" aria-expanded="false" aria-controls="collapse-celulares-computadoras-3" [innerHTML]="faqs[3].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-celulares-computadoras-3" class="collapse" aria-labelledby="heading-celulares-computadoras-3" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[3].answer">

                    </p>
                  </div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="sectionId == 'comida-restaurante'">
              <div class="card  mt-2">
                <div class="card-header" id="heading-comida-restaurante-0" data-toggle="collapse" data-target="#collapse-comida-restaurante-0" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-comida-restaurante-0" aria-expanded="false" aria-controls="collapse-comida-restaurante-0" [innerHTML]="faqs[0].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-comida-restaurante-0" class="collapse" aria-labelledby="heading-comida-restaurante-0" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[0].answer">

                    </p>
                  </div>
                </div>
              </div>
              <div class="card  mt-2">
                <div class="card-header" id="heading-comida-restaurante-1" data-toggle="collapse" data-target="#collapse-comida-restaurante-1" style="background: #fff">
                  <h3 class="mb-0 text-left">
                    <button class="btn btn-link text-left nowrap" type="button" data-toggle="collapse"
                            data-target="#collapse-comida-restaurante-1" aria-expanded="false" aria-controls="collapse-comida-restaurante-1" [innerHTML]="faqs[1].ask">
                    </button>
                  </h3>
                </div>
                <div id="collapse-comida-restaurante-1" class="collapse" aria-labelledby="heading-comida-restaurante-1" data-parent="#faq">
                  <div class="card-body">
                    <p class=" w-100 text-justify " [innerHTML]="faqs[1].answer">

                    </p>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </article>
      </div>
    </div>
  </div>
</section>
